var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { EventEmitter, TemplateRef } from '@angular/core';
import { AbstractDwFormItemComponent } from '../../form-field/abstract-dw-form-item-component';
import { InputBoolean } from '../../../utils/convert';
var AbstractDwFormPickComponent = /** @class */ (function (_super) {
    __extends(AbstractDwFormPickComponent, _super);
    function AbstractDwFormPickComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dwAllowClear = true;
        _this.dwAutoFocus = false;
        _this.dwDisabled = false;
        _this.dwPopupStyle = {};
        _this.dwStyle = {};
        _this.dwOnOpenChange = new EventEmitter();
        return _this;
    }
    __decorate([
        InputBoolean(),
        __metadata("design:type", Boolean)
    ], AbstractDwFormPickComponent.prototype, "dwAllowClear", void 0);
    __decorate([
        InputBoolean(),
        __metadata("design:type", Boolean)
    ], AbstractDwFormPickComponent.prototype, "dwAutoFocus", void 0);
    __decorate([
        InputBoolean(),
        __metadata("design:type", Boolean)
    ], AbstractDwFormPickComponent.prototype, "dwDisabled", void 0);
    return AbstractDwFormPickComponent;
}(AbstractDwFormItemComponent));
export { AbstractDwFormPickComponent };
